import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";
import {
  customEmailProviderSchema,
  customEmailSenderSchema,
} from "./custom-email-sender";

export const setCustomEmailSendersProviderForTeam = {
  name: "setCustomEmailSendersProviderForTeam" as const,
  input: z.object({
    teamId: zExt.objectId(),
    provider: customEmailProviderSchema,
  }),
  output: z.object({
    switched: z.array(customEmailSenderSchema),
    skipped: z.array(
      z.object({
        integrationId: z.string(),
        email: z.string(),
        reason: z.string(),
      }),
    ),
  }),
};
